// import React, { useState } from 'react';
// import axios from 'axios';

// export default function RoleSelector() {
//   const [role, setRole] = useState('');
//   const [status, setStatus] = useState('');

//   const handleSubmit = async () => {
//     setStatus('Generating roadmap...');
//     try {
//       const { data } = await axios.post('/api/generate-roadmap', {
//         userId: 995,
//         selectedRole: role
//       });
//       setStatus(data.message);
//     } catch (err) {
//       setStatus('Error generating roadmap.');
//     }
//   };

//   return (
//     <div className="p-10 max-w-xl mx-auto">
//       <h1 className="text-2xl font-bold mb-4">Career Roadmap Generator</h1>
//       <input
//         type="text"
//         className="w-full p-2 border rounded mb-4"
//         placeholder="Enter desired role (e.g. Blockchain Developer)"
//         value={role}
//         onChange={(e) => setRole(e.target.value)}
//       />
//       <button
//         onClick={handleSubmit}
//         className="bg-blue-600 text-white px-4 py-2 rounded"
//       >
//         Generate Roadmap
//       </button>
//       <p className="mt-4 text-sm text-gray-600">{status}</p>
//     </div>
//   );
// }


// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
// import Header from '../../../../RMS/Components/Layout/Header';

// const CareerGpt = () => {
  

//   return (
//     <div className="bg-black h-screen overflow-hidden overflow-y-auto bg-cover">
//       <div className="bg-Fabcbg bg-cover bg-center w-full h-full font-worksans">
//         <Header />
//         <div className="relative">
//           <div className="absolute w-full flex justify-between z-0">
//             <div
//               style={{
//                 background:
//                   'radial-gradient(50% 50% at 50% 50%, rgba(158, 110, 230, 0.28) 0%, rgba(158, 110, 230, 0) 100%)',
//               }}
//               className="w-[35rem] h-[35rem] opacity-45 blur rounded-full"
//             ></div>
//             <div
//               style={{
//                 background:
//                   'radial-gradient(50% 50% at 50% 50%, rgba(92, 195, 250, 0.28) 0%, rgba(92, 195, 250, 0) 100%)',
//               }}
//               className="w-[35rem] h-[35rem] opacity-45 blur rounded-full"
//             ></div>
//           </div>

//           <div className="pt-12 text-white z-10">
//             <h1 className="text-[#CDCDCD] text-3xl md:text-4xl text-center font-bold">
//               Welcome to <span className="text-[#28FBFF]">GPT</span>
//             </h1>
//             <p className="lg:w-[50%] md:w-[70%] w-[95%] mx-auto font-poppins text-center text-xs md:text-sm mt-5">
//             Let GPT power your productivity. Ask questions, automate writing, explore ideas — all in one smart assistant.
//             </p>

//             <div className="w-[90%] mx-auto font-poppins">
//               <div className="bg-[#D9D9D91C] border border-white/65 rounded-2xl p-2 flex items-center max-w-5xl mx-auto mt-12 backdrop-blur-md">
//                 <input
//                   type="text"
//                   placeholder="Enter your Requirement as Prompt (eg. I'm looking for a frontend developer with 2 years experience knowledge HTML, CSS)"
//                   className="w-[75%] bg-transparent outline-none text-white flex-1 px-4 placeholder-[#F4F5F6] placeholder:italic placeholder:text-xs text-sm"
//                 />
//                 <button
//                   className="flex items-center bg-gradient-to-r from-[#0051FF]/65 to-[#00E5FF]/65 text-white border border-[#51CBFF]/60 px-4 md:px-6 py-2 rounded-full text-sm font-medium"
//                 >
//                   <p className="md:block hidden">Search</p>
//                   <span className="md:ml-2">
//                     <FontAwesomeIcon icon={faMagnifyingGlass} />
//                   </span>
//                 </button>
//               </div>
//               <div className="mt-6">
//                 <img src="/assets/DNA/HeroPopup.png" alt="wizard" className="mx-auto max-h-[400px]" />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CareerGpt;


import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CareerRoadmapApp = ({roadmapData}) => {
  const [activeTab, setActiveTab] = useState('skills');
  const [showDetails, setShowDetails] = useState({});
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  // Sample data based on your response
  const roadmapData1 = {
    requiredSkills: [
      {"skill": "HTML/CSS", "description": "Knowledge of HTML/CSS is essential for any front-end developer. They are the building blocks of web development."},
      {"skill": "JavaScript", "description": "JavaScript is a key tool for front-end development. It allows for functional website and app design."},
      {"skill": "React.js", "description": "React.js is a popular JavaScript library for building user interfaces, particularly for single-page applications."},
      {"skill": "Vue.js", "description": "Vue.js is a progressive JavaScript framework used to create user interfaces."},
      {"skill": "UX/UI Design", "description": "Understanding of UX/UI design principles to create a smooth user experience."},
      {"skill": "Version Control/Git", "description": "Version control is an essential skill for any developer. Git is the most commonly used version control system."},
      {"skill": "Testing/Debugging", "description": "Knowledge of testing frameworks and debugging is required to build robust applications."}
    ],
    skillGap: [
      {"missingSkill": "React.js", "improvementSteps": "Take an online course to learn React.js. Practice building small projects to understand its concepts."},
      {"missingSkill": "Vue.js", "improvementSteps": "Start with basic online tutorials for Vue.js. Develop a simple application to get hands-on experience."},
      {"underdevelopedSkill": "JavaScript", "currentProficiency": "29%", "improvementSteps": "Work on more JavaScript-centric projects. Practice problem-solving in JavaScript on online platforms like LeetCode."},
      {"underdevelopedSkill": "SQL", "currentProficiency": "39%", "improvementSteps": "Although not a core requirement, SQL can be useful for front-end developers. Consider strengthening your knowledge through online courses or tutorials."}
    ],
    beginner: {
      courses: [
        {"courseTitle": "HTML, CSS, and Javascript for Web Developers", "platform": "Coursera", "URL": "https://www.coursera.org/learn/html-css-javascript-for-web-developers", "durationInWeeks": "4"},
        {"courseTitle": "Introduction to React.js", "platform": "edX", "URL": "https://www.edx.org/professional-certificate/react-js", "durationInWeeks": "5"},
        {"courseTitle": "Vue.js Essential Training", "platform": "LinkedIn Learning", "URL": "https://www.linkedin.com/learning/vue-js-essential-training-2", "durationInWeeks": "2"}
      ],
      projectIdeas: ["Create a basic website with HTML, CSS, and JavaScript", "Develop a simple React.js or Vue.js application"]
    },
    intermediate: {
      courses: [
        {"courseTitle": "Advanced JavaScript Concepts", "platform": "Udemy", "URL": "https://www.udemy.com/course/javascript-advanced/", "durationInWeeks": "8"},
        {"courseTitle": "UX Design for Developers", "platform": "edX", "URL": "https://www.edx.org/professional-certificate/ux-design-for-developers", "durationInWeeks": "7"},
        {"courseTitle": "Version Control with Git", "platform": "Coursera", "URL": "https://www.coursera.org/learn/version-control-with-git", "durationInWeeks": "4"}
      ],
      projectIdeas: ["Develop a more complex single-page application using React.js or Vue.js", "Create a portfolio website showcasing your projects"]
    },
    advanced: {
      courses: [
        {"courseTitle": "Advanced CSS and Sass", "platform": "Udemy", "URL": "https://www.udemy.com/course/advanced-css-and-sass/", "durationInWeeks": "8"},
        {"courseTitle": "Mastering Software Testing with JUnit 5", "platform": "Coursera", "URL": "https://www.coursera.org/learn/software-testing-junit5", "durationInWeeks": "3"}
      ],
      projectIdeas: ["Develop a full-stack web application incorporating both front-end and back-end", "Contribute to an open-source project on GitHub"]
    },
    futureRoles: [
      {
        "roleTitle": "Senior Front End Developer",
        "estimatedSalaryRange": "$90,000 - $130,000",
        "jobMarketTrends": "As businesses continue to invest in their digital presence, the demand for Senior Front End Developers is on the rise."
      },
      {
        "roleTitle": "UI/UX Designer",
        "estimatedSalaryRange": "$75,000 - $110,000",
        "jobMarketTrends": "With an increasing emphasis on user experience in digital products, the demand for UI/UX Designers is growing."
      },
      {
        "roleTitle": "Full Stack Developer",
        "estimatedSalaryRange": "$80,000 - $120,000",
        "jobMarketTrends": "Full Stack Developers are highly sought after due to their versatility and comprehensive knowledge of multiple tech stacks."
      }
    ]
  };

  const toggleDetails = (index) => {
    setShowDetails(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

//   const downloadPDF = () => {
//     // Create PDF content
//     const pdfContent = `
// Career Roadmap Report
// =====================

// Required Skills:
// ${roadmapData.requiredSkills.map(skill => `• ${skill.skill}: ${skill.description}`).join('\n')}

// Skill Gaps:
// ${roadmapData.skillGap.map(gap => `• ${gap.missingSkill || gap.underdevelopedSkill}: ${gap.improvementSteps}`).join('\n')}

// Learning Path:

// Beginner Level:
// ${roadmapData.beginner.courses.map(course => `• ${course.courseTitle} (${course.platform}) - ${course.durationInWeeks} weeks`).join('\n')}

// Intermediate Level:
// ${roadmapData.intermediate.courses.map(course => `• ${course.courseTitle} (${course.platform}) - ${course.durationInWeeks} weeks`).join('\n')}

// Advanced Level:
// ${roadmapData.advanced.courses.map(course => `• ${course.courseTitle} (${course.platform}) - ${course.durationInWeeks} weeks`).join('\n')}

// Future Career Roles:
// ${roadmapData.futureRoles.map(role => `• ${role.roleTitle}: ${role.estimatedSalaryRange}\n  ${role.jobMarketTrends}`).join('\n')}
//     `;

//     const blob = new Blob([pdfContent], { type: 'text/plain' });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = 'career-roadmap.txt';
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     URL.revokeObjectURL(url);
//   };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100
      }
    }
  };

  const tabs = [
    { id: 'skills', label: 'Required Skills', color: 'from-blue-500 to-purple-600' },
    { id: 'gaps', label: 'Skill Gaps', color: 'from-red-500 to-pink-600' },
    { id: 'learning', label: 'Learning Path', color: 'from-green-500 to-blue-500' },
    { id: 'careers', label: 'Future Roles', color: 'from-yellow-500 to-red-500' }
  ];




    const wrapText = (ctx, text, x, y, maxWidth, lineHeight) => {
    const words = text.split(' ');
    let line = '';
    let currentY = y;

    for (let n = 0; n < words.length; n++) {
      const testLine = line + words[n] + ' ';
      const metrics = ctx.measureText(testLine);
      const testWidth = metrics.width;
      
      if (testWidth > maxWidth && n > 0) {
        ctx.fillText(line, x, currentY);
        line = words[n] + ' ';
        currentY += lineHeight;
      } else {
        line = testLine;
      }
    }
    ctx.fillText(line, x, currentY);
    return currentY + lineHeight;
  };

  const downloadPDF = async () => {
    setIsGeneratingPDF(true);
    
    try {
      // Create a large canvas for high quality PDF
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      // Set high resolution
      const scale = 3;
      canvas.width = 2480 * scale; // A4 width in pixels at 300 DPI
      canvas.height = 3508 * scale; // A4 height in pixels at 300 DPI
      
      ctx.scale(scale, scale);
      
      const pageWidth = 2480;
      const pageHeight = 3508;
      let currentY = 60;
      
      // Background gradient
      const bgGradient = ctx.createLinearGradient(0, 0, pageWidth, pageHeight);
      bgGradient.addColorStop(0, '#1e1b4b');
      bgGradient.addColorStop(0.5, '#7c3aed');
      bgGradient.addColorStop(1, '#ec4899');
      ctx.fillStyle = bgGradient;
      ctx.fillRect(0, 0, pageWidth, pageHeight);
      
      // Header
      ctx.fillStyle = '#ffffff';
      ctx.font = 'bold 48px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('🚀 CAREER ROADMAP DASHBOARD', pageWidth / 2, currentY + 40);
      
      ctx.font = '24px Arial';
      ctx.fillStyle = '#e879f9';
      ctx.fillText('Your Personalized Path to Success', pageWidth / 2, currentY + 80);
      
      currentY += 150;
      
      // Function to create section header
      const createSectionHeader = (title, color, emoji) => {
        // Section background
        const sectionGradient = ctx.createLinearGradient(60, currentY, pageWidth - 60, currentY + 80);
        sectionGradient.addColorStop(0, color + '40');
        sectionGradient.addColorStop(1, color + '20');
        ctx.fillStyle = sectionGradient;
        ctx.fillRect(60, currentY, pageWidth - 120, 80);
        
        // Section border
        ctx.strokeStyle = color;
        ctx.lineWidth = 3;
        ctx.strokeRect(60, currentY, pageWidth - 120, 80);
        
        // Section title
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 32px Arial';
        ctx.textAlign = 'left';
        ctx.fillText(`${emoji} ${title}`, 100, currentY + 50);
        
        currentY += 120;
      };
      
      // Required Skills Section
      createSectionHeader('REQUIRED SKILLS', '#3b82f6', '💡');
      
      ctx.font = '18px Arial';
      ctx.fillStyle = '#ffffff';
      
      roadmapData.requiredSkills.forEach((skill, index) => {
        // Skill card background
        const skillGradient = ctx.createLinearGradient(100, currentY, pageWidth - 100, currentY + 100);
        skillGradient.addColorStop(0, '#3b82f640');
        skillGradient.addColorStop(1, '#8b5cf640');
        ctx.fillStyle = skillGradient;
        ctx.fillRect(100, currentY, pageWidth - 200, 100);
        
        // Skill card border
        ctx.strokeStyle = '#60a5fa';
        ctx.lineWidth = 2;
        ctx.strokeRect(100, currentY, pageWidth - 200, 100);
        
        // Skill title
        ctx.fillStyle = '#60a5fa';
        ctx.font = 'bold 20px Arial';
        ctx.fillText(skill.skill, 120, currentY + 30);
        
        // Skill description
        ctx.fillStyle = '#e5e7eb';
        ctx.font = '16px Arial';
        currentY = wrapText(ctx, skill.description, 120, currentY + 55, pageWidth - 240, 20);
        
        currentY += 40;
      });
      
      currentY += 40;
      
      // Skill Gap Section
      createSectionHeader('SKILL GAP ANALYSIS', '#ef4444', '📊');
      
      roadmapData.skillGap.forEach((gap) => {
        // Gap card background
        const gapGradient = ctx.createLinearGradient(100, currentY, pageWidth - 100, currentY + 120);
        gapGradient.addColorStop(0, '#ef444440');
        gapGradient.addColorStop(1, '#ec489940');
        ctx.fillStyle = gapGradient;
        ctx.fillRect(100, currentY, pageWidth - 200, 120);
        
        // Gap card border
        ctx.strokeStyle = '#f87171';
        ctx.lineWidth = 2;
        ctx.strokeRect(100, currentY, pageWidth - 200, 120);
        
        // Gap title
        ctx.fillStyle = '#fca5a5';
        ctx.font = 'bold 20px Arial';
        const skillName = gap.missingSkill || gap.underdevelopedSkill;
        ctx.fillText(skillName, 120, currentY + 30);
        
        // Proficiency badge if available
        if (gap.currentProficiency) {
          ctx.fillStyle = '#dc2626';
          ctx.fillRect(pageWidth - 280, currentY + 10, 120, 30);
          ctx.fillStyle = '#ffffff';
          ctx.font = '14px Arial';
          ctx.textAlign = 'center';
          ctx.fillText(gap.currentProficiency, pageWidth - 220, currentY + 30);
          ctx.textAlign = 'left';
        }
        
        // Improvement steps
        ctx.fillStyle = '#f3f4f6';
        ctx.font = '16px Arial';
        currentY = wrapText(ctx, gap.improvementSteps, 120, currentY + 60, pageWidth - 240, 20);
        
        currentY += 50;
      });
      
      currentY += 40;
      
      // Learning Path Section
      createSectionHeader('LEARNING PATH', '#10b981', '📚');
      
      const levels = ['beginner', 'intermediate', 'advanced'];
      const levelColors = ['#10b981', '#f59e0b', '#8b5cf6'];
      const levelEmojis = ['🌱', '🚀', '⭐'];
      
      levels.forEach((level, levelIndex) => {
        // Level header
        ctx.fillStyle = levelColors[levelIndex];
        ctx.font = 'bold 24px Arial';
        ctx.fillText(`${levelEmojis[levelIndex]} ${level.toUpperCase()} LEVEL`, 120, currentY + 30);
        
        currentY += 60;
        
        // Courses
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 18px Arial';
        ctx.fillText('📖 Courses:', 140, currentY + 20);
        currentY += 40;
        
        roadmapData[level].courses.forEach((course) => {
          // Course card
          const courseGradient = ctx.createLinearGradient(160, currentY, pageWidth - 160, currentY + 80);
          courseGradient.addColorStop(0, levelColors[levelIndex] + '30');
          courseGradient.addColorStop(1, levelColors[levelIndex] + '10');
          ctx.fillStyle = courseGradient;
          ctx.fillRect(160, currentY, pageWidth - 320, 80);
          
          ctx.strokeStyle = levelColors[levelIndex];
          ctx.lineWidth = 1;
          ctx.strokeRect(160, currentY, pageWidth - 320, 80);
          
          // Course details
          ctx.fillStyle = '#ffffff';
          ctx.font = 'bold 16px Arial';
          ctx.fillText(course.courseTitle, 180, currentY + 25);
          
          ctx.fillStyle = '#d1d5db';
          ctx.font = '14px Arial';
          ctx.fillText(`${course.platform} • ${course.durationInWeeks} weeks`, 180, currentY + 50);
          
          currentY += 100;
        });
        
        // Project Ideas
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 18px Arial';
        ctx.fillText('💡 Project Ideas:', 140, currentY + 20);
        currentY += 40;
        
        roadmapData[level].projectIdeas.forEach((project) => {
          ctx.fillStyle = '#e5e7eb';
          ctx.font = '16px Arial';
          ctx.fillText('• ' + project, 160, currentY + 20);
          currentY += 30;
        });
        
        currentY += 40;
      });
      
      // Future Roles Section
      createSectionHeader('FUTURE CAREER OPPORTUNITIES', '#f59e0b', '💼');
      
      roadmapData.futureRoles.forEach((role) => {
        // Role card
        const roleGradient = ctx.createLinearGradient(100, currentY, pageWidth - 100, currentY + 150);
        roleGradient.addColorStop(0, '#f59e0b40');
        roleGradient.addColorStop(1, '#ef444440');
        ctx.fillStyle = roleGradient;
        ctx.fillRect(100, currentY, pageWidth - 200, 150);
        
        ctx.strokeStyle = '#fbbf24';
        ctx.lineWidth = 2;
        ctx.strokeRect(100, currentY, pageWidth - 200, 150);
        
        // Role title
        ctx.fillStyle = '#fbbf24';
        ctx.font = 'bold 22px Arial';
        ctx.fillText(role.roleTitle, 120, currentY + 35);
        
        // Salary badge
        ctx.fillStyle = '#059669';
        ctx.fillRect(120, currentY + 50, 300, 35);
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 16px Arial';
        ctx.textAlign = 'center';
        ctx.fillText(role.estimatedSalaryRange, 270, currentY + 72);
        ctx.textAlign = 'left';
        
        // Market trends
        ctx.fillStyle = '#f3f4f6';
        ctx.font = '16px Arial';
        currentY = wrapText(ctx, role.jobMarketTrends, 120, currentY + 105, pageWidth - 240, 20);
        
        currentY += 60;
      });
      
      // Footer
      currentY += 60;
      ctx.fillStyle = '#e879f9';
      ctx.font = 'bold 20px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('🌟 Your Journey to Success Starts Here! Keep Learning and Growing! 🌟', pageWidth / 2, currentY);
      
      ctx.fillStyle = '#a855f7';
      ctx.font = '16px Arial';
      ctx.fillText('Generated by Career Roadmap Dashboard', pageWidth / 2, currentY + 40);
      
      // Convert canvas to blob and download
      canvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'career-roadmap-colorful.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        setIsGeneratingPDF(false);
      }, 'image/png', 1.0);
      
    } catch (error) {
      console.error('Error generating PDF:', error);
      setIsGeneratingPDF(false);
    }
  };


  return (
    <motion.div 
      className="min-h-screen bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-900 p-6"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <motion.div 
          className="text-center mb-8"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-5xl font-bold text-white mb-4 bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent">
            Career Roadmap Dashboard
          </h1>
          <p className="text-xl text-purple-200">Your personalized path to success</p>
        </motion.div>

        {/* Navigation Tabs */}
        <motion.div 
          className="flex flex-wrap justify-center gap-4 mb-8"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {tabs.map((tab) => (
            <motion.button
              key={tab.id}
              variants={itemVariants}
              onClick={() => setActiveTab(tab.id)}
              className={`px-6 py-3 rounded-full font-semibold text-white transition-all duration-300 ${
                activeTab === tab.id 
                  ? `bg-gradient-to-r ${tab.color} shadow-lg scale-105` 
                  : 'bg-white/20 hover:bg-white/30'
              }`}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {tab.label}
            </motion.button>
          ))}
        </motion.div>

        {/* Download Button */}
        <motion.div 
          className="text-center mb-8"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.5, type: "spring", stiffness: 150 }}
        >
          <motion.button
            onClick={downloadPDF}
            disabled={isGeneratingPDF}
            className={`${
              isGeneratingPDF 
                ? 'bg-gray-500 cursor-not-allowed' 
                : 'bg-gradient-to-r from-emerald-500 to-teal-600 hover:shadow-xl'
            } text-white px-8 py-4 rounded-full font-bold text-lg shadow-lg transition-all duration-300`}
            whileHover={!isGeneratingPDF ? { scale: 1.05, boxShadow: "0 20px 40px rgba(0,0,0,0.3)" } : {}}
            whileTap={!isGeneratingPDF ? { scale: 0.95 } : {}}
          >
            {isGeneratingPDF ? (
              <span className="flex items-center gap-2">
                <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-b-transparent"></div>
                Generating Colorful PDF...
              </span>
            ) : (
              '🎨 Download Colorful Career Roadmap'
            )}
          </motion.button>
          {isGeneratingPDF && (
            <p className="text-purple-200 mt-2 text-sm">
              Creating your beautiful PDF report... This may take a moment!
            </p>
          )}
        </motion.div>


        {/* Content */}
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.3 }}
            className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 shadow-2xl"
          >
            {activeTab === 'skills' && (
              <motion.div variants={containerVariants} initial="hidden" animate="visible">
                <h2 className="text-3xl font-bold text-white mb-6 text-center">Required Skills</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {roadmapData.requiredSkills.map((skill, index) => (
                    <motion.div
                      key={index}
                      variants={itemVariants}
                      className="bg-gradient-to-br from-blue-500/20 to-purple-600/20 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:border-white/40 transition-all duration-300"
                      whileHover={{ scale: 1.02, y: -5 }}
                    >
                      <h3 className="text-xl font-bold text-cyan-300 mb-3">{skill.skill}</h3>
                      <p className="text-white/80 text-sm leading-relaxed">{skill.description}</p>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            )}

            {activeTab === 'gaps' && (
              <motion.div variants={containerVariants} initial="hidden" animate="visible">
                <h2 className="text-3xl font-bold text-white mb-6 text-center">Skill Gap Analysis</h2>
                <div className="space-y-6">
                  {roadmapData.skillGap.map((gap, index) => (
                    <motion.div
                      key={index}
                      variants={itemVariants}
                      className="bg-gradient-to-r from-red-500/20 to-pink-600/20 backdrop-blur-sm rounded-2xl p-6 border border-white/20"
                      whileHover={{ scale: 1.01 }}
                    >
                      <div className="flex justify-between items-start mb-4">
                        <h3 className="text-xl font-bold text-red-300">
                          {gap.missingSkill || gap.underdevelopedSkill}
                        </h3>
                        {gap.currentProficiency && (
                          <span className="bg-red-500/30 text-red-200 px-3 py-1 rounded-full text-sm">
                            {gap.currentProficiency}
                          </span>
                        )}
                      </div>
                      <p className="text-white/80 leading-relaxed">{gap.improvementSteps}</p>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            )}

            {activeTab === 'learning' && (
              <motion.div variants={containerVariants} initial="hidden" animate="visible">
                <h2 className="text-3xl font-bold text-white mb-6 text-center">Learning Path</h2>
                <div className="space-y-8">
                  {['beginner', 'intermediate', 'advanced'].map((level, levelIndex) => (
                    <motion.div
                      key={level}
                      variants={itemVariants}
                      className={`bg-gradient-to-r ${
                        level === 'beginner' ? 'from-green-500/20 to-blue-500/20' :
                        level === 'intermediate' ? 'from-yellow-500/20 to-orange-500/20' :
                        'from-purple-500/20 to-pink-500/20'
                      } backdrop-blur-sm rounded-2xl p-6 border border-white/20`}
                    >
                      <h3 className="text-2xl font-bold text-white mb-4 capitalize">{level} Level</h3>
                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <div>
                          <h4 className="text-lg font-semibold text-cyan-300 mb-3">Courses</h4>
                          {roadmapData[level].courses.map((course, index) => (
                            <motion.div
                              key={index}
                              className="bg-white/5 rounded-lg p-4 mb-3 hover:bg-white/10 transition-all duration-300"
                              whileHover={{ x: 10 }}
                            >
                              <h5 className="font-semibold text-white">{course.courseTitle}</h5>
                              <p className="text-sm text-purple-200">{course.platform} • {course.durationInWeeks} weeks</p>
                              <a 
                                href={course.URL} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-cyan-400 hover:text-cyan-300 text-sm underline"
                              >
                                View Course →
                              </a>
                            </motion.div>
                          ))}
                        </div>
                        <div>
                          <h4 className="text-lg font-semibold text-cyan-300 mb-3">Project Ideas</h4>
                          {roadmapData[level].projectIdeas.map((project, index) => (
                            <motion.div
                              key={index}
                              className="bg-white/5 rounded-lg p-4 mb-3"
                              whileHover={{ scale: 1.02 }}
                            >
                              <p className="text-white">{project}</p>
                            </motion.div>
                          ))}
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            )}

            {activeTab === 'careers' && (
              <motion.div variants={containerVariants} initial="hidden" animate="visible">
                <h2 className="text-3xl font-bold text-white mb-6 text-center">Future Career Roles</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {roadmapData.futureRoles.map((role, index) => (
                    <motion.div
                      key={index}
                      variants={itemVariants}
                      className="bg-gradient-to-br from-yellow-500/20 to-red-500/20 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:border-white/40 transition-all duration-300"
                      whileHover={{ scale: 1.05, rotateY: 5 }}
                      style={{ transformStyle: 'preserve-3d' }}
                    >
                      <h3 className="text-xl font-bold text-yellow-300 mb-3">{role.roleTitle}</h3>
                      <div className="mb-4">
                        <span className="bg-green-500/30 text-green-200 px-3 py-1 rounded-full text-sm font-semibold">
                          {role.estimatedSalaryRange}
                        </span>
                      </div>
                      <p className="text-white/80 text-sm leading-relaxed">{role.jobMarketTrends}</p>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            )}
          </motion.div>
        </AnimatePresence>

        {/* Footer */}
        <motion.div 
          className="text-center mt-12"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1, duration: 0.6 }}
        >
          <p className="text-purple-200">
            🚀 Your journey to success starts here! Keep learning and growing.
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default CareerRoadmapApp;


